<div class="d-flex flex-column">
  <div class="flex-item">
    <rask-action-button class="float-end" (click)="add()" icon="far fa-plus" [disabled]="!hasRoleProduktAdmin">Lägg till</rask-action-button>
  </div>
  @if (extraHsRh && colDef) {
    <rask-table class="flex-item" [data]="extraHsRh" [columns]="colDef" (change)="onChange($event)"></rask-table>
  }
</div>

<div class="d-flex py-4">
  <div class="flex-item">
    <rask-button (click)="close()">Stäng</rask-button>
  </div>
</div>

